import { TFunction } from 'react-i18next';
import { SIM_PRODUCT_ACTION, SimProductAction } from '../constants/simProductActions';

export const getActionTranslation = (action: SimProductAction, t: TFunction) => {
  switch (action) {
    case SIM_PRODUCT_ACTION.ACTIVATE:
      return t('products.sim.actions.activate');
    case SIM_PRODUCT_ACTION.SUSPEND:
      return t('products.sim.actions.suspend');
    case SIM_PRODUCT_ACTION.UNSUSPEND:
      return t('products.sim.actions.unsuspend');
    case SIM_PRODUCT_ACTION.TERMINATE:
      return t('products.sim.actions.terminate');
    case SIM_PRODUCT_ACTION.CANCEL_LOCATION:
      return t('products.sim.actions.cancelLocation');
  }
};

export const getActionTranslationName = (action: SimProductAction, t: TFunction) => {
  switch (action) {
    case SIM_PRODUCT_ACTION.ACTIVATE:
      return t('products.sim.actions.activation');
    case SIM_PRODUCT_ACTION.SUSPEND:
      return t('products.sim.actions.suspension');
    case SIM_PRODUCT_ACTION.UNSUSPEND:
      return t('products.sim.actions.unsuspension');
    case SIM_PRODUCT_ACTION.TERMINATE:
      return t('products.sim.actions.termination');
    case SIM_PRODUCT_ACTION.CANCEL_LOCATION:
      return t('products.sim.actions.locationCancellation');
  }
};
